export interface IEnvironment {
    production: boolean;
    apiBaseUrl: string;
    loginUrl: string;
    remitAppUrl: string;
    adminAppUrl: string;
    adminApiBaseUrl: string;
    phiAppUrl: string;
    billerApiBaseUrl: string;
    studiesAppUrl: string;
    healthPayAppUrl: string;
    threadsAppUrl: string;
    automateAppUrl?: string;
    custodianAppUrl?: string;
    billerAppUrl: string;
    chartsAppUrl: string;
    chartsV2AppUrl: string;
    clinicV3AppUrl: string;
    signatureKey: string;
    aiApiUrl: string;
    engageAppUrl: string;
    engageApiBaseUrl: string;
    /** Socket.io server for Engage realtime (referral-updated, message-new) — same host as Engage API in wa-engage-v2. */
    engageSocketUrl: string;
    phiChartsBaseUrl: string;
    /**
     * When not `false`, saved views use PHI `apiBaseUrl` + `GET`/`POST`/`PATCH`/`DELETE api/v1/views`.
     */
    worksheetViewsRestSyncEnabled?: boolean;
    /**
     * When not `false`, worklists use PHI `apiBaseUrl` + `GET`/`POST`/`PATCH`/`DELETE api/v1/worklists` (debounced sync after edits).
     */
    worksheetWorklistsRestSyncEnabled?: boolean;
    /**
     * When not `false`, worklist saved-view badges prefetch Engage `GET …/referrals?page=1&limit=…` per view
     * (snapshot query params only) and read **`total`** for counts — without loading the grid for each view.
     */
    worksheetReferralsViewCountsRestEnabled?: boolean;
    /**
     * When `true` with {@link worksheetReferralsViewCountsRestEnabled}, skip the initial worklist grid load until
     * the user picks **All** or a saved view (optional bandwidth saver).
     */
    worksheetReferralsViewCountsDeferInitialGrid?: boolean;
    /**
     * When `true`, Engage medications UIs show sample rows if APIs/cache return none.
     * When explicitly `false`, worklist prospect reconciliation tile stays empty even in non-production.
     * When omitted in non-production, prospect tile uses demo meds when lists are empty (see engage component).
     */
    seedEngageMedicationsDemo?: boolean;
    /**
     * When `true`, worklist prospect header preferred-pharmacy strip shows sample pharmacy when patient has none (local UI preview only).
     */
    seedEngagePreferredPharmacyDemo?: boolean;
    /**
     * When `true`, Engage worklist prospect Overview sidebar shows sample rows when real data is absent (local UI preview only).
     */
    seedEngageProspectOverviewDemo?: boolean;
    /** When set, users who belong to this org skip the company picker and are switched here automatically. */
    preferredClinicCompanyId?: string;
    /** Auth SPA (wa-account-v2) — cross-app logout entry. */
    authAppUrl?: string;
    /** Ask Aya BFF for private conversation APIs (`https://dev-aya.healthexam.ai/api/aya`, etc.). */
    ayaApiBaseUrl?: string;
    /** Ask Aya web app — tile launch + default BFF host (dev-aya / qa-aya / aya). */
    ayaAppUrl?: string;
    /** aya-health-chat / www entry — final landing after sign-out. */
    ayaHealthChatAppUrl?: string;
}

export enum AvailableApplication {
    Admin = 'admin',
    Remit = 'remit',
    Phi = 'phi',
    Biller = 'biller',
    Studies = 'studies',
    Charts = 'charts',
    ChartsV2 = 'chartsv2',
    ClinicV3 = 'clinic',
    Vascunote = 'vascunote',
    Engage = 'engage'
}